import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)

import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

require('@/store/subscriber')

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['X-APP-TYPE'] = 'suppliers';

import dateLatin from './utils/date.filter'
import capitalize from './utils/text.filters'
import numeros from './utils/number.filters'

Vue.filter('capitalize', capitalize)
Vue.filter('dateLatin', dateLatin.dateLatin)
Vue.filter('dateStringDetailed', dateLatin.dateStringDetailed)
Vue.filter('FloatToFixed', numeros.FloatToFixed)
Vue.filter('MoneyFormat', numeros.MoneyFormat)
Vue.filter('AbsolutNumber', numeros.AbsolutNumber)

Vue.config.productionTip = false

store.dispatch('auth/attempt', localStorage.getItem('token'))
.then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})
